<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>

        <grantDialog v-if="showGrantDialog"
                     :formData="formData"
                     :loading="dialogLoading"
                     @closeDialog="closeDialog"
                     @submitForm="submitForm">
        </grantDialog>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import editDialog from '@/components/system/rolemanage/editDialog'
    import grantDialog from '@/components/system/rolemanage/grantTableDialog'

    export default {
        name: 'rolemanage',
        props: ['menuData'],
        components: {
            tableGrid,
            toolBar,
            editDialog,
            grantDialog
        },
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "角色名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                formData: {},
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showEditDialog: false,
                showGrantDialog: false,
                dialogLoading: false,

                headList: [
                    {
                        column_name: '_px',
                        column_comment: '序号',
                        column_width: '55'
                    },
                    {
                        column_name: 'rnumber',
                        column_comment: '角色编码',
                        column_width: '250'
                    },
                    {
                        column_name: 'roleName',
                        column_comment: '角色名称',
                        column_width: '350',
                        type: 'hover'
                    },
                    {
                        column_name: 'roleType',
                        column_comment: '角色类型',
                        column_width: '250'
                    },
                    {
                        column_name: 'remark',
                        column_comment: '备注',
                    },
                ],
            }
        },
        mounted() {
            this.getListData() // 初始化表格数据
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url:"/role/list",
                    param:{
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.roleList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
                this.$refs.tableGrid.clearSelList();
            },

            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {
                    this.formData = {
                        roleType:'公司岗位'
                    };
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    if (type === "edit") {
                        this.showEditDialog = true;
                    }

                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/role/delete",
                            param: {
                                roleId: this.formData.roleId,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.getListData);
                    }
                }
                if (type === "grant") {
                    this.formData = selList;
                    if (!this.$pub.isEmptyObjct(selList)) {
                        this.showGrantDialog = true;
                    } else {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }
                }
            },
            tableOpt(type, data) {
                // console.log(type, data)
            },

            closeDialog() {
                this.showEditDialog = false;
                this.showGrantDialog = false;
            },
            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;

                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.save(param, "/role/save");
                this.dialogLoading = false;

                if (data.infoCode === '0') {
                    this.$refs.tableGrid.clearSelList();
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }
    }
</style>
